import { HttpStatusCode, PejHttpError } from '@common-lib';

import { baseClient } from '../common';
import { ChangeForgottenPasswordModel } from './change-forgotten-password.model';
import { ForgotPasswordModel } from './forgot-password.model';
import { LoginModel } from './login.model';
import { LoginResponseModel } from './login-response.model';
import { PasswordlessLoginModel } from './passwordless-login.model';

const apiUrl = '/api/auth';

export const authClient = {
  async login(model: LoginModel): Promise<LoginResponseModel> {
    return await baseClient.body({
      body: model,
      method: 'POST',
      url: `${apiUrl}/login`,
    });
  },

  async passwordlessLogin(
    model: PasswordlessLoginModel,
  ): Promise<LoginResponseModel> {
    return await baseClient.body({
      body: model,
      method: 'POST',
      url: `${apiUrl}/passwordless-login`,
    });
  },

  async logout(): Promise<void> {
    return await baseClient.get(`${apiUrl}/logout`);
  },

  async verify() {
    try {
      await baseClient.get(`${apiUrl}/verify`);
      return true;
    } catch (error) {
      console.error(error);
      if (error instanceof PejHttpError) {
        if (error.statusCode === HttpStatusCode.UNAUTHORIZED) {
          return false;
        }
      }

      throw error;
    }
  },

  async changeForgottenPassword(
    model: ChangeForgottenPasswordModel,
  ): Promise<LoginResponseModel> {
    return await baseClient.body({
      body: model,
      method: 'POST',
      url: `${apiUrl}/change-forgotten-password`,
    });
  },

  async forgotPassword(model: ForgotPasswordModel): Promise<void> {
    return await baseClient.body({
      body: model,
      method: 'POST',
      url: `${apiUrl}/forgot-password`,
    });
  },

  async verifyEmail(verifyEmailToken: string): Promise<LoginResponseModel> {
    return await baseClient.get(`${apiUrl}/verify-email/${verifyEmailToken}`);
  },
};
